// <countdown-timer datetime="2026-09-01T00:00:00-05:00"> … </countdown-timer>
//
// Used by the homepage's featured "Countdown" card (see
// templates/_macros/imageTextFeatured.twig -> countdown macro). The day/hour/
// minute/second values are rendered server-side into [data-unit] spans so the
// card never flashes zeros; this just keeps them current once a second and
// stops itself when the target is reached.
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const iso = this.getAttribute("datetime");
    this.target = iso ? new Date(iso).getTime() : NaN;

    this.units = {};
    this.querySelectorAll("[data-unit]").forEach((el) => {
      this.units[el.dataset.unit] = el;
    });

    if (Number.isNaN(this.target) || !Object.keys(this.units).length) return;

    this.update = this.update.bind(this);
    this.update();
    this.timer = window.setInterval(this.update, 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  update() {
    let remaining = Math.floor((this.target - Date.now()) / 1000);
    if (remaining <= 0) {
      remaining = 0;
      window.clearInterval(this.timer);
    }

    const values = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };

    for (const [unit, el] of Object.entries(this.units)) {
      if (values[unit] === undefined) continue;
      const next = String(values[unit]).padStart(2, "0");
      if (el.textContent !== next) el.textContent = next;
    }
  }
}

if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}
